import { Box, Paper, Typography, Button, IconButton } from "@mui/material";
import { FiMoreVertical } from "react-icons/fi";
import concreteImg from "../../../assets/categories/concrete.png";
import openingsImg from "../../../assets/categories/openings.png";
import exteriorImg from "../../../assets/categories/exterior.png";
import finishingsImg from "../../../assets/categories/finishings.png";
import masonryImg from "../../../assets/categories/masonry.png";
import thermalImg from "../../../assets/categories/thermal.png";
import woodImg from "../../../assets/categories/wood.png";
import metalsImg from "../../../assets/categories/metals.png";
import roofConstImg from "../../../assets/categories/roof_construction.png";
import floorConstImg from "../../../assets/categories/floor_construction.png";
import interiorDoorsImg from "../../../assets/categories/interior_doors.png";
import stairConstImg from "../../../assets/categories/stair_construction.png";
import slabFoundImg from "../../../assets/categories/slab_foundation.png";
import roofCoveringImg from "../../../assets/categories/roof_covering.png";
import roofOpeningImg from "../../../assets/categories/roof_opening.png";
import specialFoundationImg from "../../../assets/categories/special_foundation.png";
import slabOnGradeImg from "../../../assets/categories/slab_on_grade.png";

const BuildingCard = ({ building, resolvedImage, onAction, actionLabel, isTemplate = false, isDark, tok, isSelected = false, onClick, onMenuClick }) => {
  const getCategoryImage = (name = "", category = "") => {
    const n = (name || "").toLowerCase();
    const c = (category || "").toLowerCase();

    if (n.includes("roof opening")) {
      return roofOpeningImg;
    }
    if (n.includes("roof covering")) {
      return roofCoveringImg;
    }
    if (n.includes("roof construction") || n.includes("thermal")) {
      return roofConstImg;
    }
    if (n.includes("window") || n.includes("opening")) {
      return openingsImg;
    }
    if (n.includes("door") || n.includes("finishing")) {
      return interiorDoorsImg;
    }
    if (n.includes("wall") || n.includes("masonry")) {
      return masonryImg;
    }
    if (n.includes("floor") || n.includes("wood")) {
      return floorConstImg;
    }
    if (n.includes("slab on grade")) {
      return slabOnGradeImg;
    }
    if (n.includes("special foundation")) {
      return specialFoundationImg;
    }
    if (n.includes("standard foundation") || n.includes("foundation") || n.includes("concrete")) {
      return slabFoundImg;
    }
    if (n.includes("stair") || n.includes("metal")) {
      return stairConstImg;
    }
    if (c.includes("office")) {
      return exteriorImg;
    }
    return concreteImg; // default fallback
  };

  const imageSrc = resolvedImage || building.photo_url || building.photo || getCategoryImage(building.name, building.building_category);
  const brandColor = tok?.bg?.tabActive || "#659d33";

  const formattedDate = building.date_modified 
    ? new Date(building.date_modified).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
    : "30 Jul 2026";

  const displayGwp = building.gwp !== undefined && building.gwp !== null
    ? `${Number(building.gwp).toFixed(2)} kg CO₂e`
    : "0.00 kg CO₂e";

  return (
    <Paper
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "320px",
        overflow: "hidden",
        position: "relative",
        bgcolor: tok.bg.card,
        border: isSelected ? "2px solid" : "1px solid",
        borderColor: isSelected ? brandColor : tok.border.card,
        borderRadius: tok.radius.card,
        boxShadow: isSelected ? `0 0 12px rgba(101, 157, 51, 0.4)` : tok.shadow.card,
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: isSelected ? `0 0 16px rgba(101, 157, 51, 0.6)` : tok.shadow.cardHover,
        },
      }}
    >
      <Box
        sx={{
          height: "140px",
          width: "100%",
          backgroundImage: `url(${imageSrc})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.15)" }} />
        
        {/* 3-dots Context Menu Overlay */}
        {onMenuClick && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onMenuClick(e, building);
            }}
            sx={{
              position: "absolute",
              top: 8,
              left: 8,
              bgcolor: isDark ? "rgba(30, 41, 59, 0.7)" : "rgba(255, 255, 255, 0.8)",
              color: isDark ? "#fff" : "#1e293b",
              padding: "6px",
              "&:hover": {
                bgcolor: isDark ? "rgba(30, 41, 59, 0.9)" : "rgba(255, 255, 255, 0.95)",
              }
            }}
          >
            <FiMoreVertical style={{ fontSize: "16px" }} />
          </IconButton>
        )}
        
      </Box>

      <Box sx={{ p: 2, display: "flex", flexDirection: "column", flexGrow: 1, justifyContent: "space-between", minHeight: 0 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, textAlign: "left" }}>
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: "15px",
              fontWeight: 700,
              color: tok.text.primary,
              lineHeight: 1.3,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              textAlign: "left"
            }}
          >
            {building.name}
          </Typography>
          <Typography sx={{
            fontFamily: tok?.font?.family || "Poppins, sans-serif",
            fontSize: tok?.font?.size?.gridHeader || "14px",
            fontWeight: tok?.font?.weight?.medium || 500,
            color: isDark ? "rgba(255,255,255,0.72)" : "#475569",
            textAlign: "left"
          }}>
            {building.building_category || "Building Component"} • {building.location || "Global"}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1, borderTop: "1px solid", borderColor: tok.border.divider, pt: 1.5 }}>
          <Box sx={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
            <Typography sx={{ fontSize: "11px", color: isDark ? "rgba(255,255,255,0.5)" : "#94a3b8", textAlign: "left" }}>
              {isTemplate ? "Standard Template" : formattedDate}
            </Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: 600, color: isDark ? "rgba(255,255,255,0.7)" : "#475569", textAlign: "left" }}>
              1 designs
            </Typography>
          </Box>

          {isTemplate ? (
            <Button
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                onAction(building);
              }}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: "13px",
                borderColor: brandColor,
                color: brandColor,
                "&:hover": {
                  borderColor: brandColor,
                  bgcolor: isDark ? "rgba(101, 157, 51, 0.08)" : "rgba(101, 157, 51, 0.04)",
                },
              }}
            >
              {actionLabel}
            </Button>
          ) : (
            <Box
              sx={{
                borderRadius: "8px",
                border: "1px solid",
                borderColor: brandColor,
                color: brandColor,
                px: 1.5,
                py: 0.6,
                fontWeight: 700,
                fontSize: "13px",
                fontFamily: "Poppins",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: isDark ? "rgba(101, 157, 51, 0.04)" : "rgba(101, 157, 51, 0.02)",
              }}
            >
              {displayGwp}
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default BuildingCard;
